import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonBookingService } from 'src/app/bookings/shared/common-booking.service';
import { PhoneCode } from '../../../../shared/constants/countryPhoneCode.constant';
import { BaseFormGroup } from '../../../../shared/form-input-components/base-form-group';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilService } from '../../../../shared/services/util.service';
import { CreateBookingService } from '../../create-booking.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-requestor-form',
  templateUrl: './requestor-form.component.html',
  styleUrls: [
    './requestor-form.component.scss',
    '../../../../shared/styles/form.scss'
  ]
})
export class RequestorFormComponent extends BaseFormGroup implements OnInit, OnDestroy {
  @Input() formDetails: FormGroup;
  @Input() config: any[];
  @Input() reqTypeMapping: any;
  @Output() confirmCallback = new EventEmitter();
  @Input() referenceBooking:any

  private employeeKeys = ['emplId', 'name', 'gender', 'department', 'email', 'mobile', 'emplGuid', 'officeGuid'];
  private currentUser: any;
  private watcher: any;
  private isEditMode: boolean;
  phoneCodes = PhoneCode;
  private riderAddress = [];
  private destroy$ = new Subject();
  tempObj;

  reqDropdown: any;
  SelectedRequestor:any = ''
  currentUserAllData: any;
  costCenters: any[];
  costCenterNames: any;
  departmentList: any;
  departmentListName: any;
  hideRequesterForm:boolean=true
  RequestorTypeID:string

  constructor(
    private createBookingService: CreateBookingService,
    private authService: AuthService,
    private utilService: UtilService,
    private commonBookingService: CommonBookingService,
    private commonService: CommonService
  ) {
    super();
  }

  ngOnInit() { 
    this.SelectedRequestor=this.getReqMappingLabel('Self')?.label || 'Self';
    this.getDepartments();
    this.getCostCenters();
    this.commonBookingService.savedAddressesForRiders.
      pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((address) => {
        if (address) {
          this.riderAddress = address;
        }
      });
    this.isEditMode = this.createBookingService.isEditMode;
       this.setupForm();
    this.formDetails.addControl('RequestorTypeID', new FormControl());
        this.createBookingService.requestorForm.subscribe(res => {
      if (res?.selected) {
        this.tempObj = res.selectedUser;
      }
      this.SelectedRequestor = res.selectedRequestor ? res.selectedRequestor : this.formDetails.get('Requester')?.value;
    });
    this.hideRequesterForm = this.formDetails.get('Requester')?.value=='Self'  

  }

  setupForm() {
    this.authService.getUserInfo().subscribe((response) => {
      this.currentUser = response.employee;
      this.currentUserAllData = response;
      if (!Object.keys(this.formDetails.controls).length) {
        // create form using config
        this.constructForm(this.formDetails, this.config, (field) => {
          if (field.elementKey === 'RequesterSearch') {
            return true;
          }
          return false;
        });
        this.formDetails.addControl('emplGuid', new FormControl(''));
        this.formDetails.addControl('officeGuid', new FormControl(''));
          this.onRequesterSelect(response.employee);
      } else {
        if(this.referenceBooking?.requester?.emplGuid){
          if(this.referenceBooking.requester.emplGuid==this.currentUser.guid){
            this.formDetails.get('Requester').setValue('Self')
            this.SelectedRequestor=this.getReqMappingLabel('Self'); 
          }
          else{
            this.SelectedRequestor=this.getReqMappingLabel('Firm Member'); 
            this.formDetails.get('Requester').setValue('Firm Member')
            this.hideRequesterForm=false
          }
          this.createBookingService.requestorForm.next({selected: true, selectedUser: this.referenceBooking.requester, selectedRequestor: this.SelectedRequestor?.label});
          // calling this fn here to trigger an event which shows input forms on the basis of req type
           this.onRequesterTypeSelect(this.SelectedRequestor)
        }
        this.formDetails.addControl('officeGuid', new FormControl(this.currentUser.office.guid));
      }
    });

    // set watcher on requester type to reset form
    if (this.formDetails &&  this.formDetails.get('Requester')){
    this.watcher = this.formDetails.get('Requester').valueChanges.subscribe(this.setRequesterInfo.bind(this));
    this.watcher = this.formDetails.get('paymentType').valueChanges.subscribe(this.setPaymentType.bind(this));
   }
  }

  setRequesterInfo = (requesterType: string) => {
    if (requesterType === 'Self') {
      this.onRequesterSelect(this.currentUser);
    } else {
      this.onClearClick();
    }
  }
  setPaymentType = (paymentType: string) => {
    this.commonBookingService.getPaymentType(paymentType);
  }

  getPhoneCodeValue(option) {
    return option.dial_code;
  }

  getPhoneCodeLabel(option) {
    return option.name;
  }

  requestorSearch = (searchQuery: string) => {
    searchQuery = searchQuery.replace(/;/g, '');
    return this.createBookingService.fetchEmployees(searchQuery);
  }

  onConfirmClick() {
    if (this.formDetails.get('Requester').value == 'Guest'){
      this.confirmCallback.emit();
    }
  else{
  if (this.formDetails.valid && this.tempObj.primaryAddress) {
    this.tempObj.primaryAddress.home.employeeId = this.tempObj.employeeId;
    this.tempObj.primaryAddress.home.isSaved = true;
    this.tempObj.primaryAddress.home.type = `${this.tempObj.employeeName}'s Home`;
    this.riderAddress.push(this.tempObj.primaryAddress.home);
    this.commonBookingService.updateHomeAddressesOfRiders(this.riderAddress);
    this.confirmCallback.emit();
  } else {
    this.markFormGroupDirty(this.formDetails);
  }
}
  }

  getUserOptionLabel(option: any) {
    return `${option.employeeName} (${option.employeeId})`;
  }

  getUserOptionValue(option: any) {
    return option;
  }

  onRequesterSelect(selected) {
   if(selected && this.RequestorTypeID=='Firm Member') this.hideRequesterForm=false
    this.tempObj = selected; 
    if (!selected) {
      return;
    }
    let contactNumber;
    if (selected.phone) {
      contactNumber = this.getPhoneAndCountryCode(selected.phone);
    }
    const selectedUser = {
      emplId: selected.employeeId,
      name: selected.employeeName,
      gender: this.utilService.capitalizeString(selected.gender),
      department: this.getCostCenterAndDepartmemntLabelFromValue(selected.departmentGuid,true),
      costCenter: this.getCostCenterAndDepartmemntLabelFromValue(selected.costCenterGuid),
      email: selected.emailId,
      mobile: contactNumber ? contactNumber[1] : selected.phone,
      phonecode: contactNumber ? contactNumber[0] : '',
      costCenterGuid: selected.costCenterGuid,
      emplGuid: selected.guid,
      officeGuid: selected.office.guid,
      businessUnit: selected.businessUnit
    };
    this.formDetails.patchValue(selectedUser);
    if (this.commonService.workflowConfig?.hideOtherRiderMobileNumber && selected){
    for (const config of this.config) {
      if (['mobile', 'alternateMobile'].includes(config.elementKey)){
        if (this.currentUser && this.currentUser?.employeeId !== selected.employeeId){
          config.config.isHidden = true;
        }else{
          config.config.isHidden = false;
        }
      }
    }
  }
    this.createBookingService.requestorForm.next({selected: true, selectedUser: selected, selectedRequestor: this.SelectedRequestor});
    for (const elementKey of this.employeeKeys) {
      if (this.formDetails.get(elementKey)) {
        this.formDetails.get(elementKey).disable();
      }
    }
  }

  getPhoneAndCountryCode(mobile, code?: string): string[] {
    let phoneCode = "";
    let phoneNumber = "";
    if (mobile && !mobile.startsWith("+")) {
      if (code && code !== "") {
        phoneCode = code;
      } else {
        phoneCode = "+91";
      }
      phoneNumber = mobile;
    } else {
      if (mobile) {
        const phoneWithCode = mobile.split('-');
        phoneCode = phoneWithCode[0];
        phoneNumber = phoneWithCode[1];
      }
    }
    return [phoneCode, phoneNumber];
  }

  onClearClick() {
    for (const key in this.formDetails.controls) {
      if (key!=='Requester' && key !== 'paymentType') {
        this.formDetails.get(key)?.enable()
        this.formDetails.get(key)?.reset()
      }
    }
    // for (const elementKey of this.employeeKeys) {
    //   if (this.formDetails.get(elementKey)) {
    //     this.formDetails.get(elementKey).enable();
    //     this.formDetails.get(elementKey).reset();
    //   }
    // }
  }
  onRequesterTypeSelect(event: {label: string, value: string}){
    this.RequestorTypeID=event.value
    // next ternary operator indicated that - 
    // IF this.referenceBooking i.e. edit flow - if req is firm member/visitor then pre-filled form will be visible (at this point the form is either in valid or disabled state)
    // and if now user selects any other req type from dropdown then the functionality will be like create flow, i.e. form will be visible on selecting an employee
    // ELSE create flow 
    this.hideRequesterForm = this.referenceBooking ? 
    !(this.RequestorTypeID === 'Guest' || (this.RequestorTypeID === 'Firm Member' && (this.formDetails.valid || this.formDetails.disabled))) : this.RequestorTypeID !== 'Guest';

    this.SelectedRequestor = event.label;
    this.formDetails.get('Requester')?.setValue(event.value);
    this.formDetails.get('RequestorTypeID')?.setValue(event.label);
    this.createBookingService.requestorForm.next({selectedRequestor: this.SelectedRequestor});

  }
  ngOnDestroy() {
    if (this.watcher) {
    this.watcher.unsubscribe();
    }
  }

  getCostCenters() {
    this.commonService.getEtsData().subscribe((response) => {
      this.commonService.costcenter.next(response.costCenters);
      this.commonService.costcenter.subscribe(response => {
        this.costCenters = response;        
        this.costCenterNames = this.costCenters.map((costCenter: any) => {
          return costCenter.name;
        });
      });
    });
  }

  getDepartments() {
    this.commonService.getEtsData().subscribe((response) => {
        this.departmentList = response.departments;
        this.departmentListName = response.departments.map((departmemt: any) => {
          return departmemt.name;
        });
    });
  }

  getCostCenterAndDepartmemntLabelFromValue(value: string, isDepartment: boolean = false): string {
    let temp = this.costCenters;
    if(isDepartment){
      temp = this.departmentList;
    }
    if(temp?.length){
      for (const elememt of temp) {
        if (elememt.guid === value) {
          return elememt.name;
        }
      }
    }
  }
  getReqMappingLabel(key){
    return this.reqTypeMapping?.find(item => item.value === key); 
  }
}
